export const LIST = 'LIST';
export const MULTI_SELECT = 'MULTI_SELECT';
export const NUMBER = 'NUMBER';
export const STRING = 'STRING';
export const PRODUCT_ATTRIBUTE = 'PRODUCT_ATTRIBUTE';
export const CUSTOM_FIELD = 'CUSTOM_FIELD';
export const EXTENDED_FIELD = 'EXTENDED_FIELD';
export const SKU = 'SKU';
export const CATEGORY = 'CATEGORY';
export const UPLOAD = 'UPLOAD';
export const ENTRY_TRIGGER_EVENT_ATTRIBUTE = 'entryTriggerEventAttribute';